import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

// .env'den ortam değişkenlerini al
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Ortam değişkenlerini kontrol et
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase ortam değişkenleri eksik. Lütfen .env dosyasını kontrol edin.');
}

// Supabase istemcisini oluştur
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    db: {
      schema: 'public'
    }
  }
);

// Supabase bağlantısını test et
export async function testSupabaseConnection() {
  try {
    const { error } = await supabase.from('user_profiles').select('count');
    if (error) throw error;
    console.log('✓ Supabase bağlantısı başarılı');
    return true;
  } catch (error) {
    console.error('Supabase bağlantı hatası:', error);
    return false;
  }
}